/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'

export default {
  getTrainings ({ commit, state }) {
    if (state.trainings.length > 0) return
    return new Promise((resolve, reject) => {
      axios.get('/cp/trainings')
        .then((response) => {
          commit('ADD_TRAININGS', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getTraining ({ commit }, uuid) {
    return new Promise((resolve, reject) => {
      axios.get(`/cp/trainings/${uuid}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createTraining ({commit}, formData) {
    return new Promise((resolve, reject) => {
      axios.post('/cp/trainings', formData)
        .then((response) => {
          commit('ADD_TRAININGS', [response.data.data])
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deleteTraining ({commit}, uuid) {
    return new Promise((resolve, reject) => {
      axios.delete(`/cp/trainings/${uuid}`)
        .then((response) => {
          commit('DELETE_TRAINING', uuid)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateTraining ({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`/cp/trainings/${payload.uuid}`, payload.trainingFormData)
        .then(response => {
          commit('DELETE_TRAINING', payload.uuid)
          commit('ADD_TRAININGS', [response.data.data])
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },
  getTrainingElements ({ commit }, uuid) {
    return new Promise((resolve, reject) => {
      axios.get(`/cp/trainings/${uuid}/training-elements`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  attachTrainingElement ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`/cp/trainings/${payload.uuid}/attach-training-element/${payload.elementUuid}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  detachTrainingElement ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`/cp/trainings/${payload.uuid}/detach-training-element/${payload.elementUuid}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  orderTrainingElements ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`/cp/trainings/${payload.uuid}/order-training-elements`, payload.order)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
